module.exports = __webpack_public_path__ + "img/checked.7259377b.svg";